import { render, staticRenderFns } from "./GuestsMetrics.vue?vue&type=template&id=08c7325d&scoped=true"
import script from "./GuestsMetrics.vue?vue&type=script&lang=js"
export * from "./GuestsMetrics.vue?vue&type=script&lang=js"
import style0 from "./GuestsMetrics.vue?vue&type=style&index=0&id=08c7325d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c7325d",
  null
  
)

export default component.exports